<template>
    <client-page class="app--main">
        <!-- S: 메인 비주얼 -->
        <v-container class="container--large">
            <main-visual code="main-pc" pc></main-visual>
            <!-- <main-visual code="main-mobile" mobile></main-visual> -->
        </v-container>
        <!-- E: 메인 비주얼 -->

         <!-- S: Auctions -->
        <section class="main-section--auctions pt-0">
            <v-container class="container--large">
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <router-link to="/auction-halls/A" class="main-section--auctions__link d-block px-10 py-40 pa-lg-50">
                            <div class="tit-wrap tit-wrap--sm">
                                <h3 class="tit font-weight-regular line-height-1">Live Auction</h3>
                            </div>
                            <v-btn text color="primary" class="pa-4 ml-auto mr-n4 font-weight-medium">VIEW MORE <i class="icon icon-bar mt-2 ml-6"></i></v-btn>
                        </router-link>
                    </v-col>

                    <!-- <v-col cols="12" md="4">
                        <router-link to="/auction-halls/C" class="main-section--auctions__link d-block px-10 py-40 pa-lg-50">
                            <div class="tit-wrap tit-wrap--sm">
                                <h3 class="tit font-weight-regular line-height-1">(구) Live Auction</h3>
                            </div>
                            <v-btn text color="primary" class="pa-4 ml-auto mr-n4 font-weight-medium">VIEW MORE <i class="icon icon-bar mt-2 ml-6"></i></v-btn>
                        </router-link>
                    </v-col> -->

                    <v-col cols="12" md="6">
                        <router-link to="/private-sales/LIST" class="main-section--auctions__link d-block px-10 py-40 pa-lg-50">
                            <div class="tit-wrap tit-wrap--sm">
                                <h3 class="tit font-weight-regular line-height-1">Private Sales</h3>
                            </div>
                            <v-btn text color="primary" class="pa-4 ml-auto mr-n4 font-weight-medium">VIEW MORE <i class="icon icon-bar mt-2 ml-6"></i></v-btn>
                        </router-link>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <!-- E: Auctions -->

        <!-- S: Text Banner -->
        <v-container class="container--large">
            <!-- <main-text-banner code="main-text-banner"></main-text-banner> -->
            <main-text-banner></main-text-banner>
        </v-container>
        <!-- E: Text Banner -->

        <!-- S: Permanent Sales -->
        <main-section title="Permanent Sales" class="main-section--permanent">
            <template slot="title-actions">
                <v-btn small text color="primary" class="pa-4 ml-auto mr-n4" to="/permanent-sales">VIEW MORE <i class="icon icon-bar mt-2 ml-6"></i></v-btn>
            </template>
            <main-permanent-sales />
        </main-section>
        <!-- E: Permanent Sales -->

        <!-- S: main link -->
        <div class="main-section main-section--link">
            <v-container class="container--large">
                <div class="mx-xl-n110">
                    <v-divider class="border-top grey-38"></v-divider>
                    <v-row no-gutters>
                        <v-col cols="12" md="4">
                            <div class="px-10 py-50 px-md-20 px-lg-40 py-lg-60 px-xl-120 py-xl-100">
                                <div class="tit-txt-wrap mb-20 mb-md-40">
                                    <div class="tit-wrap mb-6 mb-md-10">
                                        <h2 class="tit font-weight-regular">KATA YouTube</h2>
                                    </div>
                                    <p class="tit-txt">영상으로 보는 미술이야기</p>
                                </div>
                                <v-row class="row--small">
                                    <v-col cols="6" v-for="{ text, value } in categoriesYoutube" :key="value">
                                        <v-btn small block text height="auto" color="primary" class="justify-start px-0 py-4" :to="`/board/youtube?category=${value}`">{{ text }}</v-btn>
                                        <v-divider class="border-top grey-38"></v-divider>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="px-10 py-50 px-md-20 px-lg-40 py-lg-60 px-xl-120 py-xl-100">
                                <div class="tit-txt-wrap mb-20 mb-md-40">
                                    <div class="tit-wrap mb-6 mb-md-10">
                                        <h2 class="tit font-weight-regular">KATA Report</h2>
                                    </div>
                                    <p class="tit-txt">보고서를 통한 유익한 핵심정보</p>
                                </div>
                                <v-row class="row--small">
                                    <v-col cols="6" v-for="{ text, value } in categoriesReport" :key="value">
                                        <v-btn small block text height="auto" color="primary" class="justify-start px-0 py-4" :to="`/board/report?category=${value}`">{{ text }}</v-btn>
                                        <v-divider class="border-top grey-38"></v-divider>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="px-10 py-50 px-md-20 px-lg-40 py-lg-60 px-xl-120 py-xl-100">
                                <div class="tit-txt-wrap mb-20 mb-md-40">
                                    <div class="tit-wrap mb-6 mb-md-10">
                                        <h2 class="tit font-weight-regular">KATA Archives</h2>
                                    </div>
                                    <p class="tit-txt">서식과 자료 중심의 이야기</p>
                                </div>
                                <v-row class="row--small">
                                    <v-col cols="6" v-for="{ text, value } in categoriesForms" :key="value">
                                        <v-btn small block text height="auto" color="primary" class="justify-start px-0 py-4" :to="`/board/forms?category=${value}`">{{ text }}</v-btn>
                                        <v-divider class="border-top grey-38"></v-divider>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </div>
        <popup-layer />
    </client-page>
</template>

<script>
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainSection from "@/components/client/main/main-section.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import MainTextBanner from "@/components/client/main/main-text-banner.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainPermanentSales from "@/components/client/main/main-permanent-sales.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        MainSection,
        MainVisual,
        MainTextBanner,
        // BoardList,
        PopupLayer,
        MainPermanentSales,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
};
</script>